<template>
  <VRow no-gutters class="profile-row">
    <VCol v-if="label" cols="12" :class="['profile-label', isFocused && 'focused']">
      <span v-text="label" />
    </VCol>
    <VCol cols="12">
      <VTextarea
        class="m-textarea m-common"
        autocomplete="off"
        v-bind="$attrs"
        hide-details="auto"
        :loader-height="1"
        solo
        flat
        v-on="$listeners"
        @focus="isFocused = true"
        @blur="isFocused = false"
      >
        <template v-for="(_, scopedSlotName) in $scopedSlots" #[scopedSlotName]="slotData">
          <slot :name="scopedSlotName" v-bind="slotData" />
        </template>
        <template v-for="(_, slotName) in $slots" #[slotName]>
          <slot :name="slotName" />
        </template>
      </VTextarea>
    </VCol>
  </VRow>
</template>

<style lang="stylus">
  .profile-row
    font-size: 14px
    white-space: pre-wrap
    overflow-wrap: break-word
    .profile-label
      font-size: 12px
      color: var(--v-strong-base)
      opacity: 0.8
      &.focused
        color: var(--v-strong-base)
        opacity: 1
</style>

<script lang="ts">
import { defineComponent } from '@mimir/web/compat/vueCompat';
import { VCol, VRow, VTextarea } from 'vuetify/lib';

export default defineComponent({
  name: 'MTextArea',
  components: {
    VCol,
    VRow,
    VTextarea,
  },
  inheritAttrs: false,
  props: {
    label: {
      type: String,
    },
  },
  data() {
    return {
      isFocused: false,
    };
  },
});
</script>
